import { useLocation } from 'react-router';
import { Toaster } from 'sonner';

export function AppToaster() {
  const location = useLocation();
  const isKiosk = location.pathname.startsWith('/kiosk');

  return <Toaster position={isKiosk ? 'bottom-center' : 'top-center'} />;
}
